module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"edipartHeader":"Maintenance EDI Parts"},"no":{"edipartHeader":"Vedlikehold EDI parter"}}')
  delete Component.options._Ctor
}
